import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  signal,
  computed,
} from "@angular/core";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzRadioComponent, NzRadioGroupComponent } from "ng-zorro-antd/radio";
import _ from "lodash";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs";
import * as moment from "moment";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { DateService } from "@root/shared/service/date.service";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Child, MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";

interface NoteStatus {
  status: "none" | "editing";
  text: string;
  originalText: string;
  list?: Array<string>;
}

type Available = 0 | 1 | -1;

interface Data {
  available: Available;
  note: string;
  stop_status: number;
}

@Component({
  selector: "host-hostex-panel",
  templateUrl: "./hostex-panel.component.html",
  styleUrls: ["./hostex-panel.component.scss"],
})
export class HostexPanelComponent implements OnInit, OnDestroy {
  note: NoteStatus = {
    status: "none",
    originalText: "",
    text: "",
    list: [],
  };
  available: Available = -1;
  hasStopDates = false; // 是否包含停用的日期

  selectedHouses = signal<Option[]>([]);
  selectedHouseIds = computed<number[]>(() => this.selectedHouses()?.map((house) => house.value));

  @Input()
  set entity(entity: Child) {
    // 默认选中当前房间
    this.selectedHouses.set([
      {
        label: entity.c_title,
        value: entity.c_id,
      },
    ]);

    this.fetchStatusInfo(entity.c_id);
  }
  @Input() nights;
  @Input() dateRange: Array<string | Date> = [];
  @Input() listOfForbiddenDates = [];
  @Output() success = new EventEmitter();
  @ViewChild("radioBtnGroup") radioBtnGroup: NzRadioGroupComponent;
  disabledDate = (date: Date) => {
    const format = moment(date).format("YYYY-MM-DD");

    const head = moment().subtract(1, "d");
    const last = moment().add(24, "month");
    // const head = moment().subtract(90, 'd');
    // const last = moment().add(90, 'd');

    return this.listOfForbiddenDates.indexOf(format) !== -1 || !moment(date).isBetween(head, last, "d");
  };
  private destroy$ = new Subject();

  constructor(
    private httpService: HouseStatusService,
    private houseCalendarService: MultiHouseCalendarService,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private translate: TranslateService,
    private dateService: DateService,
    private router: Router,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.houseCalendarService.requestUpdateAvailableRaw$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      // 检查是否有停用的日期
      if (this.isAvailableChangeable(res)) {
        this.requestUpdateAvailable(res);
      } else {
        this.displayOpenStopDatesWarning();
      }
    });
  }

  /**
   *  房态页获取所选日期的房态信息
   */
  private fetchStatusInfo(id) {
    const params = {
      begin: moment(_.head(this.dateRange)).format("YYYY-MM-DD"),
      end: moment(_.last(this.dateRange)).format("YYYY-MM-DD"),
      house_ids: JSON.stringify([id]),
      version: "2.4",
    };
    this.http.get("/api/calendar/optimized_list", { params }).subscribe((res: HttpRsp) => {
      const data: Data[] = res?.data?.calendar_list?.[0]?.calendar || [];
      if (data) {
        this.updateStatus(data);
        this.updateNote(data);
        this.hasStopDates = !!data.find((item) => item.stop_status === 1);
      }
    });
  }

  checkDateIsInRange() {
    const end = _.last(this.dateRange);
    const endLimit = moment().add(6, "month");

    if (endLimit.isAfter(end, "d")) {
      return true;
    }
    // 仅可操作7个月内的日期
    const warningText = this.translate.t("warning.available_within_seven_months");
    this.messageService.info(warningText);
    return false;
  }

  updateStatus(calendars: Array<Data> = []) {
    let available: Available = -1;
    if (calendars.length === 1) {
      const calendar = _.head(calendars) || ({} as Data);
      available = calendar.available;
    } else if (calendars.length !== 0) {
      const result = _.reduce(calendars, (sum, n) => sum + n.available, 0);
      if (result === calendars.length) {
        available = 1;
      } else {
        available = result === 0 ? 0 : -1;
      }
    }
    this.available = available;
  }

  updateNote(calendars: Array<Data> = []) {
    /**
     * 分为有备注和无备注两种
     * 无备注 - text为空
     *
     * 有备注 - text不为空
     */
    const status: "none" | "editing" = "none";

    const notes = _.map(
      _.filter(calendars, (c) => c.note),
      "note",
    );
    const list = _.uniq(notes);

    const text = list.length > 1 ? null : _.head(list);
    const originalText = text;

    this.note = { status, text, list, originalText };
  }

  requestUpdateAvailable(forceAvailable?) {
    if (this.selectedHouses().length === 0) {
      this.messageService.warning(this.translate.t("warning.sidebar.house_required"));
      return;
    }

    const available = this.available;
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");
    const house_ids = this.selectedHouseIds();

    const params = {
      house_ids: JSON.stringify(house_ids),
      begin,
      end,
      available,
    };

    // if (available !== -1) {
    //   _.assign(params, { available });
    // }

    if (!_.isUndefined(forceAvailable)) {
      _.assign(params, { available: forceAvailable });
    }

    this.httpService.batchSetAvailable(params).subscribe((res) => {
      if (res?.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  onChangeDate(value) {
    const head = moment(_.head(value)).subtract(1, "d");
    const last = _.last(value);
    this.nights = moment(last).diff(head, "days");
  }

  onClickCancel() {
    this.success.emit();
  }

  @WritePermissionGurd("calendar")
  onClickSave() {
    this.requestUpdateAvailable();
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  onAvailableChange(value) {
    const origin = this.available;
    if (!this.isAvailableChangeable(value)) {
      this.displayOpenStopDatesWarning();
      // this.available = origin;
      // todo 强行更改组件内部的值不是一个好的实践，只是组件目前提供的接口似乎无法正确更改值，暂时处理
      this.radioBtnGroup.writeValue(origin);
    } else {
      this.available = value;
    }
  }

  onSelectHouses(values) {
    this.selectedHouses.set(values);
  }

  onRemoveHouse(value: number) {
    const list = this.selectedHouses().filter((house) => house.id !== value);
    this.selectedHouses.set(list);
  }

  private isAvailableChangeable(available) {
    return !(available && this.hasStopDates);
  }

  private displayOpenStopDatesWarning() {
    this.modalService.warning({
      // nzTitle: '该房间已停用，无法打开房态，需前往房间设置页关闭停用状态。',
      nzTitle: this.translate.t("calendar.sidebar.status.stop_warning.title"),
      // nzOkText: '去设置',
      nzOkText: this.translate.t("calendar.sidebar.status.stop_warning.btn"),
      nzClosable: true,
      nzMaskClosable: true,
      nzOnOk: () => {
        this.router.navigate(["/app/properties/detail"], { queryParams: { id: this.selectedHouses[0].id, subTab: 1 } });
      },
    });
  }

  // hasWritePermission() {
  //   return this.authorityService.hasWritePermission('calendar');
  // }
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
